<template>
  <div>
    <popup ref="popup" type="center" :coverClose="false">
      <div class="shortTerm" id="ProvisionalUpgrade">
        <div class="closeOrOpen">
          <img @click="close()" alt="" src="./img/vip_plan/close.png"/>
        </div>
        <div class="closeTitle">
          <div v-if="titleNum===1" class="bigTitle">会员<span class="supmoney">专享红包</span>正在为您派发......请稍后</div>
          <div v-if="titleNum===1" class="smallTitle">此红包为系统自动抽中幸运用户派发（概率极低），仅限今日有效（请务必珍惜）！</div>

          <div v-if="titleNum===2&&!obtain_fail" class="bigTitle">恭喜您，成功升级为 <span>{{ userInfo.vip_name }}</span>
          </div>
          <div v-if="titleNum===2&&!obtain_fail" class="smallTitle">感谢支持，{{
              site_name
            }}回馈给您一份儿大额优惠券，请笑纳
          </div>
          <div v-if="titleNum===2&&obtain_fail" class="bigTitle"><span>很遗憾，领取失败</span></div>
          <div v-if="titleNum===2&&obtain_fail" class="smallTitle">失败原因：上一张被领取的优惠券被成功使用</div>

          <div v-if="titleNum===3" class="bigTitle">专享红包<span>领取成功</span>，请尽快完成升级</div>
          <!-- <div v-if="titleNum===3" class="smallTitle">每人仅派发一次，放弃将视为自动放弃（下次续费无优惠，请务必珍惜）</div> -->
          <div v-if="titleNum===3" class="smallTitle smallTitle_other">
            <!-- 专享红包有效期截止：<div class="countdown-display">{{ formattedTime }}</div> &nbsp;结束（未完成支付升级，视为自动放弃） -->
             您已成功领取<span class="bgcolw">{{userInfo.vip_type==1?'200元':userInfo.vip_type==2?'150元':'80元'}}</span> 专享红包，仅需再支付 <span class="bgcolw">{{ pay_money }}元</span> 即可升级为<span class="bgcolw">永久会员</span>，还可额外获赠<span class="bgcolw bgcolwBig">{{ detailData.upgrade_good.gift_score }}</span>积分奖励
              
            <!-- 付费成功后，您的会员有效期至{{ endDate }}（100年） -->
          </div>
        </div>
        <div class="closeCenter">
          <div v-if="titleNum===1">
            <div class="sendCoupons">
              <div>
                <img alt="" src="./img/vip_plan/loading.gif" height="32" width="32"/>
              </div>

              <div>正在为您派发专享红包.....请稍等..... <span>({{ timeNum }}S)</span></div>
            </div>
          </div>
          <div v-if="titleNum===2">
            <div :class="['getCoupons',obtain_fail?'yes1':'NO_1']">
              <div class="collectFail" v-if="obtain_fail">
                <img class="img_1" src="./img/vip_plan/collectFail.png" alt="">
                <p class="p_1">很遗憾，领取失败</p>
                <p class="p_2">失败原因：上一张被领取的优惠券被成功使用</p>
                <div class="zhi_1">
                  <span>仅剩最后1次机会，手慢无</span> <img class="img_2" src="./img/vip_plan/choose_1.png" alt="">
                </div>
              </div>
              <div :class="['fifty',obtain_fail?'bg_fifty2':'bg_fifty1']"
                   @click="fetchQuan">
                <div class="fiftyLeft">
                  限永久会员购买使用
                </div>
                <div class="fiftyRight">
                  <div class="rightOne">
                    付费会员专属福利
                  </div>
                  <div class="rightTwo">
                    每一位付费会员限领一次，过期自动失效
                  </div>
                  <div class="rightThree">
                    <span class="one">
                      限领一次
                    </span>
                    <span class="two">
                      历史最低
                    </span>
                    <span class="three">
                      仅限今天
                    </span>
                  </div>
                  <div>
                    注:此活动将于{{ tipMsgDate }}日截止（最后一天）
                  </div>
                </div>
                <div class="qiang" v-if="obtain_fail">
                  <img src="./img/vip_plan/shouzhi.png" alt="">
                </div>
              </div>
              <div class="receive" v-if="!obtain_fail">
                <div class="receive_left">
                  每人 <span class="towNum">2</span> 次领取机会，共计 <span v-for="index in peopleNum">{{ index }}</span>
                  位用户已领取
                </div>
                <div>
                  <img alt="" src="./img/vip_plan/choose.png"/>
                </div>
              </div>
            </div>
          </div>

          <div class="centerRight" v-show="titleNum==3">
            <!-- <div class="titleF">
              <div>
                您已成功领取50元专享红包，
              </div>
              <div>
                仅需再支付 <span>{{ pay_money }}元</span> 即可升级为<span>永久会员</span>
              </div>
            </div> -->
            <div class="three_bot">
              <div class="three_botLef">
                <div class="qrCode">
                  <div class="qrCode_left">
                    <div class="topLeft"></div>
                    <div class="bottomLeft"></div>
                  </div>
                  <div class="qrCode_center">
                    <canvas class="timeout" id="canvasHdUpgrade"></canvas>
                    <div class="time_out_cover" v-if="timerout" flex-center @click="refreshQrCode">
                      二维码已过期，点击刷新
                    </div>
                  </div>
                  <div class="qrCode_right">
                    <div class="topRight"></div>
                    <div class="bottomRight"></div>
                  </div>
                </div>
                <div class="script">
                  <div class="script_money">
                    <div>应付金额 &nbsp;:&nbsp; <span>{{ pay_money }}&nbsp;元</span></div>
                  </div>
                  <div class="script_prompt">
                    请用
                    <img alt="" src="./img/vip_plan/alipay.png"/>
                    或
                    <img alt="" src="./img/vip_plan/weixin.png"/>
                    扫二维码支付
                  </div>
                </div>
              </div>
              <div class="centerLeft" v-if="titleNum===3">
                <div>
                  <div class="warnung">

                    <div class="jiaobiao">
                      红包即将失效
                    </div>
                    永久会员专享红包有效期：<div class="countdown-display">{{ formattedTime }}</div> &nbsp;结束，未完成支付升级，视为自动放弃！
                    <!-- 注:此优惠活动将于{{ tipMsgDate }}截止（最后一天），请尽快完成支付! -->
                  </div>
                  <div class="statistics">
                    <div class="moneyBig">199元</div>
                    <div :class="pay_money>=100?'moneySmall':'moneySmall moneySmall_oth'">{{ pay_money }}</div>
                    <img alt="" src="./img/vip_plan/0.png" height="93" width="500" class="jiageBiaoImg"/>
                    <!-- <div class="jiageBiao"></div> -->
                    <div class="statistics_bot">
                      <div>
                        优惠{{detailData.upgrade_good.coupon_money}}元 <span>（历史最低）</span>
                      </div>
                      <div class="youhuiyibai">
                        优惠100元
                      </div>
                    </div>
                  </div>

                  <div class="kaitongData">
                    <el-carousel height="70px" direction="vertical" indicator-position='none' autoplay :interval="3000">
                      <el-carousel-item v-for="(item,index) in ganxieList" :key="item.id">
                        <div class="lettDetail">用户<span class="payTime lScro">ID：{{ ganxieList[index].user_id }}</span>在 <span class="lrScro">{{ ganxieList[index].datetime
                            }}</span>成功升级为<span class="payTime lScro">{{ ganxieList[index].vip_type }}</span></div>
                        <div class="lettDetail">用户<span class="payTime lScro">ID：{{ ganxieList[index].user_id }}</span>在 <span class="lrScro">{{ ganxieList[(index+1)>=ganxieList.length?0:(index+1)].datetime
                            }}</span>成功升级为<span class="payTime lScro">{{ ganxieList[(index+1)>=ganxieList.length?0:(index+1)].vip_type }}</span></div>
                      </el-carousel-item>
                    </el-carousel>
                    <img src="./img/vip_plan/conlaba1.png" alt="" class="conlabarigBot" />
                  </div>
                                    <!-- <div class="remind">
                     注:此优惠活动将于{{ tipMsgDate }}截止（最后一天），请尽快完成支付!
                  </div> -->

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </popup>
  </div>

</template>

<script type="text/ecmascript-6">
import popup from "COMPONENTS/Popup.vue"
import QRCode from 'qrcode'
import utils from '@/utils'

export default {
  components: {popup},
  props: [],
  data() {
    return {
      num: 1,
      titleNum: 1,
      timeNum: 5,
      timer: null,
      peopleNum: [8, 7, 3, 9, 5],
      tipMsgDate: "",
      endDate: "",
      uniq_key: '',
      timerout: false,
      pay_time: 0,
      code_url: '',

      closePrompt: false,
      pay_money: "",
      site_name: "",
      obtain_fail: false,
      remainingTime: 10 * 60 * 1000, // 10分钟（毫秒）
      isRunning: false,
      timerDown: null,
      ganxieList: [
        {
          id: 0,
          datetime: utils.getRandomTimeToday(),
          user_id: "2716**",
          vip_type: "永久会员"
        },
        {
          id: 1,
          datetime: utils.getRandomTimeToday(),
          user_id: "2716**",
          vip_type: "永久会员"
        }, {
          id: 2,
          datetime: utils.getRandomTimeToday(),
          user_id: "2716**",
          vip_type: "永久会员"
        }, {
          id: 3,
          datetime: utils.getRandomTimeToday(),
          user_id: "2716**",
          vip_type: "永久会员"
        }, {
          id: 4,
          datetime: utils.getRandomTimeToday(),
          user_id: "2716**",
          vip_type: "永久会员"
        }, {
          id: 5,
          datetime: utils.getRandomTimeToday(),
          user_id: "2716**",
          vip_type: "永久会员"
        },
      ],
      detailData:{}
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    formattedTime() {
        const minutes = Math.floor(this.remainingTime / (60 * 1000));
        const seconds = Math.floor((this.remainingTime % (60 * 1000)) / 1000);
        const milliseconds = this.remainingTime % 1000;
        const padZero = (num) => num.toString().padStart(2, '0');
  
        return `${padZero(minutes)}:${padZero(seconds)}:${padZero(milliseconds).slice(0, 2)}`;
    }
  },
  created() {
    this.site_name = SITE_NAME

    const now = new Date();
    const year = now.getFullYear(); // 获取当前年份
    const month = now.getMonth() + 1; // 获取当前月份，注意getMonth()返回的是0-11，所以需要加1
    const day = now.getDate(); // 获取当前日期
    this.tipMsgDate = year + '-' + month + '-' + day;
    this.endDate = (year + 100) + '-' + month + '-' + day;
  },
  beforeDestroy() {
    // this.clearTimer()

  },
  methods: {
    //顶部倒计时
    //顶部
    startCountdown() {
      if (this.isRunning) return;
      this.isRunning = true;

      // 每10毫秒更新一次（流畅版，可改为100毫秒降低性能消耗）
      this.timerDown = setInterval(() => {
        this.remainingTime -= 10;
 
        if (this.remainingTime <= 0) {
          clearInterval(this.timerDown);
          this.remainingTime = 0;
          this.isRunning = false;
          //时间到 取消
          this.$store.commit('setHeader_r_show',1)
        }
      }, 10);
    },
    handelCoupon() {
      // 缓存用户领取优惠时间
      console.log('缓存用户领取优惠时间')
      let nowB = new Date().getTime()
      let form = new Date()
      let y = form.getFullYear();
      let m = form.getMonth() + 1;
      let d = form.getDate();
      let nowE = new Date(y, m, d, "23", "59", "59").getTime()
      let ttl = nowE - nowB
      this.setCache("vipForeverQuan", 1, ttl);
      // 保存支付的时间
      this.$store.commit('showVipTime', true)
      localStorage.setItem('vip_time', Date.now())
    },
    // popClose() {
    //   this.$refs.popup.close();
    //   this.$router.push("/membership")
    // },
    show() {
      // 还原css 使关闭后的弹窗还原为初始状态
      setTimeout(() => {
        let payPopEl = document.querySelector('#ProvisionalUpgrade')
        payPopEl.classList.remove('paynewBoxDon') 
      });

      let vipForeverQuan = this.getCache("vipForeverQuan") || 0;
      this.obtain_fail = false

      if (vipForeverQuan == 1) {
        console.log('vipForeverQuan===1')
        // 当天领取过优惠券
        this.titleNum = 3
        this.fetchPayQrCode()
        this.startCountdown()
      } else {
        console.log('vipForeverQuan!=1')
        this.titleNum = 1
        this.timeNum = 5
        this.startTimer()

      }

      this.handelCoupon()
      this.$refs.popup.show();
      // this.startTimer()
    },
    setDetail(data){
      this.detailData = data
      this.pay_money = parseInt(data.upgrade_good.pay_money) - data.upgrade_good.coupon_money
    },
    // show(){

    // },
    close() {
      // this.$refs.popup.close();
      // this.titleNum =2
      // return

      this.handelCoupon()
      if (this.closePrompt) {
        console.log(11111)
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
        let payPopEl = document.querySelector('#ProvisionalUpgrade')
        payPopEl.classList.add('paynewBoxDon')
        setTimeout(() => {
          this.$refs.popup.close();
          // payPopEl.classList.remove('paynewBoxDon')
          this.closePrompt = false
          localStorage.setItem('setIsSuperImg',true)
          if(this.userInfo.vip_type == 5){
            //判断加桌
            this.$emit('addDesk')
          }else{
            if(localStorage.getItem('ling2')){
              localStorage.setItem('heade_r_show', Date.now())
              localStorage.setItem('heade_r_show2', 2)
              //判断加桌
              this.$emit('addDesk')
              
            }else{
              //弹出翻倍优惠券
              this.$store.commit('setSecYouh',true)
              // localStorage.removeItem('zz_vipForeverQuan')
              localStorage.setItem('heade_r_show', Date.now())
            }
            this.$store.commit('setVipYouhuiHeaderShow',true)
            this.$store.commit('setHeader_r_show',2)
          }
        }, 1000);
      } else {
        console.log(22222)
        this.$confirm(
            this.titleNum === 2 ? '您还有大额优惠券未领取，您确定要放弃吗？' : this.titleNum === 1 ? '系统正在为您派发优惠券，您确定要放弃吗？' : "永久会员价格（历史最低）的活动将于" + this.tipMsgDate + "日截止（今天是最后一天），您确定要放弃吗？",
            '提示', {
              showCancelButton: false, // 是否显示取消按钮
              confirmButtonText: '好的，我已知晓',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
          // this.obtain_fail = true
          if (this.titleNum === 2) {
            this.titleNum = 1
            this.startTimer()
          } else if (this.titleNum === 1) {
            this.titleNum = 3
            this.clearTimer()
          } else {
            this.closePrompt === false ? this.closePrompt = true : false
          }
        }).catch(() => {
        });
      }
    },


    //  倒计时
    startTimer() {
      this.timer = setInterval(() => {
        this.timeNum--;
        if (this.timeNum == 0) {
          this.show()
          this.clearTimer()
        }
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      if (!this.obtain_fail) {
        console.log('clearTimer111')
        // this.obtain_fail = !this.obtain_fail
        this.titleNum = 3
      } else {
        console.log('clearTimer222')
        this.titleNum = 3
      }
        this.fetchPayQrCode()
      this.timeNum = 5
    },
    fetchQuan() {
      //  领取优惠
      this.titleNum = 1
      this.startTimer()
      // this.fetchPayQrCode()
      this.handelCoupon()
    },
    fetchPayQrCode() {
      // 获取支付二维码
      this.$http.post('/front/aimj/pay/chongzhi/?soft=mjdraw', {
        appid:APP_ID,
        pay_source:'pc',
        vip_id:`level_${this.userInfo.vip_type}`,
        pro_type:0,
        vip_type:5,
        is_upgrade:1,
        upgrade_id:`${this.userInfo.vip_type+'-1'}`
      }).then(res => {
        this.code_url = res.data.pay_url
        this.uniq_key = res.data.uniq_key
        // this.pay_money = res.data.pay_money
        this.refreshQrCode()
      })
    },
    generateRandomString() {
      // 生成随机数字（0-9）
      const randomDigit = Math.floor(Math.random() * 10);

      // 生成随机字母（A-Z或a-z）
      const randomLetterCode = Math.random() < 0.5
          ? Math.floor(Math.random() * 26) + 65   // 大写字母 A-Z (65-90)
          : Math.floor(Math.random() * 26) + 97;  // 小写字母 a-z (97-122)
      const randomLetter = String.fromCharCode(randomLetterCode);

      return randomDigit.toString() + randomLetter;
    },
    parseQueryString(queryString) {
      // 使用 URLSearchParams 解析查询字符串
      const params = new URLSearchParams(queryString);
      // 将结果转换为对象
      const result = {};
      for (const [key, value] of params) {
        result[key] = value;
      }
      return result;
    },
    refreshQrCode() {
      // 刷新二维码
      let str_url = ''
      if (this.code_url.includes('?')) {
        console.log('包含问号')
        let http_Str = this.code_url.split('?')[0]  //分割问号前的字符串
        let Url_Str = this.code_url.split('?')[1]  //分割问号后的字符串
        let Obj = this.parseQueryString(Url_Str)
        if ('refTime' in Obj) {
          console.log('对象中有 refTime 字段，值为：', Obj.refTime);
          Obj.refTime = Obj.refTime + this.generateRandomString();
        } else {
          console.log('对象中没有 refTime 字段');
          Obj.refTime = this.generateRandomString(); // 添加 refTime 字段并赋值
        }
        const pairs = [];
        // 遍历对象的每个键值对
        for (const key in Obj) {
          if (Obj.hasOwnProperty(key)) {
            // 将键值对转换为字符串格式并添加到数组中
            pairs.push(`${key}=${Obj[key]}`);
          }
        }
        str_url = http_Str + '?' + pairs.join('&');
        console.log('str_url', str_url);
      } else {
        console.log('不包含问号')
        str_url = (this.code_url += '?refTime=' + this.generateRandomString())
      }
      this.code_url = str_url;
      var canvas = document.getElementById('canvasHdUpgrade')
      QRCode.toCanvas(canvas, this.code_url, function (error) {
        if (error) console.error(error)
      })
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.getPayInfo()
    },
    getPayInfo() {
      this.pay_time = 0;
      this.timerout = false
      this.timer = setInterval(() => {
        if (this.uniq_key) {
          this.$http.get("/pay/order/status/?uniq_key=" + this.uniq_key).then((res) => {
            if (res.data.code == 1) {
              clearInterval(this.timer);
              this.timer = null

              // 支付成功 关闭弹框 提示恭喜您成为弹框
              
              this.fetchProfile()
              setTimeout(() => {
                this.$refs.popup.close();
                this.closePrompt = false
                // this.$emit("callBack");
              });
              localStorage.removeItem('vip_time')
              this.$store.commit('showVipTime', false)
            }
          })
          this.pay_time += 3;
          if (this.pay_time >= 60 * 2) {
            this.pay_time = 0;
            clearInterval(this.timer);
            this.timerout = true;
          }
        }
      }, 3000)
    },
    fetchProfile() {
      this.$http.get('/front/user/profile/?soft=mjdraw').then(res => {
        if (res.status == '200') {
          this.$store.commit("setUserInfo", res.data);
          this.$store.commit("setIsLogin", true);
          this.$store.commit('setVipCongratulationsShow', true) 
        }
      }).finally(() => {
      })
    },
  },
};
</script>
<style scoped lang="scss">
.shortTerm {
  padding: 0 30px;
  width: 900px;
  height: 570px;
  position: relative;
  background-image: url("./img/vip_plan/011.png");
  background-size: 100% 100%;
  border-radius: 13px;
  overflow: hidden;
  animation: scaleIn 1s ease-out forwards;
  @keyframes scaleIn {
    0% {
      transform:translateX(-800%);
    }

    100% {
      transform: translateX(0);
    }
  }

  .closeOrOpen {

    display: flex;
    justify-content: flex-end;
    padding: 10px 0 0 0;
    position: absolute;
    top: -3px;
    right: 10px;

    img {
      height: 25px;
      cursor: pointer;
    }
  }

  .closeTitle {
    padding-bottom: 20px;
    margin-top: 35px;

    .bigTitle {
      font-size: 36px;
      font-weight: 700;
      color: #4a3304;
      margin-bottom: 15px;
      margin-top: -20px;
      .supmoney{
        color: #fc631e;
      }

      span {
        color: #f64834;
      }
    }

    .smallTitle {
      font-size: 16px;
      color: #fc631e;
      //margin-bottom: 20px;
    }
    .smallTitle_other{
      display: flex;
      align-items: center;
      // color: #4a3304;
      .bgcolw{
        background: #fff;
        padding: 0px 8px 2px;
        border-radius: 3px;
        margin: 0 8px;
        font-size: 14px;
        font-weight: 700;
      }
      .bgcolwBig{
          padding: 2px 8px 2px;
      }
    }
  }

  .closeCenter {
    display: flex;
    justify-content: center;

    .centerLeft {
      width: 538px;
      padding: 10px 10px 0 10px;

      .warnung {
        font-size: 14px;
        color: #bf0404;
        background-color: #ffe0cf;
        padding: 10px 10px;
        border-radius: 2px;
        position: relative;
        margin-bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
        //img{
        //  position: absolute;
        //  top: 0;
        //  right: 0;
        //  height: 25px;
        //}
        .jiaobiao {
          height: 30px;
          width: 90px;
          position: absolute;
          top: -12px;
          right: -5px;
          background-image: url("./img/vip_plan/jiaobiao.png");
          background-size: contain;
          background-repeat: no-repeat;
          color: white;
          font-size: 12px;
          padding: 0px 0 0px 10px;
        }
        .countdown-display{
          background: #fff;
          // padding: 2px 8px;
          width: 71px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 3px;
        }
      }

      .statistics {

        position: relative;
        text-align: center;

        .moneyBig {
          position: absolute;
          top: 24px;
          right: 80px;
          font-size: 14px;
        }

        .moneySmall {
          position: absolute;
          top: 60px;
          left: 94px;
          font-size: 18px;
          color: white;
        }
        .moneySmall_oth{
          left: 100px;
        }
        .jiageBiaoImg{
          margin-top: 30px;
        }
        .jiageBiao {
          // background: #ccc;
          background: #ccc url('./img/vip_plan/0.png') no-repeat;
          background-size: contain;
          background-position: center;
          width: 100%;
          height: 175px;
        }

        .statistics_bot {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          padding: 9px 50px 0 60px;
          margin-bottom: 20px;
          .youhuiyibai{
            margin-right: 20px;
          }
          span {
            color: #cf4040;

          }
        }

      }

      .remind {
        // width: calc(100% - 20px);
        width: 100%;
        height: 50px;
        font-size: 16px;
        background-color: #eeeeee;
        color: #626262;
        border-radius: 5px;
        // text-align: center;
        // line-height: 50px;
        // margin: 0 auto;
      }
      .kaitongData{
        width: 100%;
        height: 90px;
        // background: #ccc;
        font-size: 14px;
        margin-top: 25px;
        background-color: #eeeeee;
        color: #626262;
        border-radius: 5px;
        padding: 15px 10px 20px 20px;
        position: relative;
        .conlabarigBot{
          position: absolute;
          right: 0px;
          bottom: 0px;
          width: 80px;
          height: 62px;
          opacity: 0.3;
        }
        .lettDetail{
          height: 30px;
          display: flex;
          align-items: center;
        }
        .payTime {
          color: #ff6463;
        }
        .lrScro {
          margin: 0 10px;
        }

        .lScro {
          // margin-left: 10px;
          margin: 0 10px;
        }
      }


    }

    .centerRight {
      width: 100%;
      padding: 20px;
      margin-top: 10px;
      //padding-top: 50px;
      .titleF {
        font-size: 20px;
        text-align: center;
        // font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;

        div {
          margin: 10px 0 20px;
        }

        span {
          color: #ba0000;
          margin: 0 10px;

        }
      }

      .three_bot {
        //width: 300px;
        display: flex;
        justify-content: space-between;
        // margin-top: 20px;
        width: 100%;
        // background: #ccc;

        .three_botLef {
          width: 270px;
          // margin: 0 10px 0 10px;
        }
      }

      .qrCode {
        width: 240px;
        height: 240px;
        margin: 0 auto;
        margin-bottom: 25px;
        margin-top: 13px;
        display: flex;
        align-items: center;
        border: 1px solid #e8e8e8;
        position: relative;

        .qrCode_left {
          height: 100%;
          width: 25px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          position: absolute;
          top: 0;
          left: 0;

          .topLeft {
            width: 25px;
            height: 25px;
            border-top: 2px solid #e85555;
            border-left: 2px solid #e85555;
          }

          .bottomLeft {
            width: 25px;
            height: 25px;
            border-bottom: 2px solid #e85555;
            border-left: 2px solid #e85555;
          }
        }

        .qrCode_center {
          width: 230px;
          height: 230px;
          position: relative;
          margin: 0 auto;

          .timeout {
            display: block;
            width: 100% !important;
            height: 100% !important;
          }

          .time_out_cover {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 5;
            cursor: pointer;
            background-color: rgba(0, 0, 0, 0.58);
            color: #fff;
            font-size: 16px;

            &:hover {
              font-size: 16px;
              font-weight: bold;
            }

            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .qrCode_right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;
          width: 25px;
          position: absolute;
          top: 0;
          right: 0;

          .topRight {
            width: 25px;
            height: 25px;
            border-top: 2px solid #e85555;
            border-right: 2px solid #e85555;
          }

          .bottomRight {
            width: 25px;
            height: 25px;
            border-bottom: 2px solid #e85555;
            border-right: 2px solid #e85555;
          }
        }
      }

      .script {
        display: flex;
        flex-direction: column;
        align-items: center;

        .script_money {
          font-size: 18px;
          font-weight: 700;

          span {
            color: #bd0000;
          }
        }

        .script_prompt {
          font-size: 16px;
          margin: 25px 0 0 0;
          display: flex;
          align-items: center;

          img {
            font-size: 0;
            width: 15px;
            height: 15px;
            margin: 0 5px;
            margin-top: 2px;
          }
        }


      }
    }

    // 优惠券等待
    .sendCoupons {
      width: 890px;
      height: 450px;
      //background-color: aquamarine;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      span {
        color: #cb3131;
      }
    }

    .sendCoupons div:first-child {
      margin-bottom: 30px;
    }

    //  领取优惠券
    .getCoupons {
      //width: 890px;
      height: 440px;
      min-width: 500px;
      //background-color: aquamarine;
      display: flex;
      flex-direction: column;
      align-items: center;

      &.yes1 {
        padding-top: 15px;
      }

      &.NO_1 {
        justify-content: center;
      }

      .collectFail {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .img_1 {
          width: 60px;
          font-size: 0;
        }

        .p_1 {
          font-size: 16px;
          font-weight: 700;
          color: #000000;
          margin: 15px 0;
        }

        .p_2 {
          font-size: 14px;
          color: #bbbbbb;
        }

        .zhi_1 {
          color: #dc433d;
          display: flex;
          margin: 20px 0 45px;
          position: relative;
          font-size: 16px;

          span {
          }

          .img_2 {
            width: 60px;
            position: absolute;
            right: -70px;
            top: -7px;
          }
        }
      }

      .fifty {
        cursor: pointer;
        //width: 590px;
        width: 510px;
        //height: 160px;
        //margin-bottom: 20px;
        background-size: contain;
        background-repeat: no-repeat;
        background-attachment: fixed;
        font-size: 10px;
        display: flex;
        //background-color: aquamarine;
        padding: 20px 28px;
        position: relative;

        &.bg_fifty1 {
          background-image: url("./img/vip_plan/1.png");
        }

        &.bg_fifty2 {
          background-image: url("./img/vip_plan/3.png");
        }

        .fiftyLeft {
          width: 110px;
          margin-right: 30px;
          display: flex;
          align-items: flex-end;
          padding-bottom: 14px;
          color: #9f6336;
        }

        .fiftyRight {
          padding: 5px 10px 10px 0;
          color: #9f6336;

          .rightOne {
            font-size: 14px;
            font-weight: 700;
            margin-bottom: 10px;
          }

          .rightTwo {

          }

          .rightThree {
            margin: 10px 0;
            color: white;

            span {
              padding: 3px 5px;
              border-radius: 2px;
              overflow: hidden;
            }

            .one {
              background-color: #9f6336;
            }

            .two {
              background-color: #dc433d;
              margin: 0 10px;
            }

            .three {
              background-color: #fad002;
            }
          }

        }

        .qiang {
          width: 65px;
          height: 65px;
          position: absolute;
          bottom: 0;
          right: 0;
          animation: finger-click 1s ease-in-out infinite alternate; /* 循环动画 */

          @keyframes finger-click {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.1);
            }
            100% {
              transform: scale(1);
            }
          }

        }
      }

      .receive {
        display: flex;
        align-items: flex-end;

        .receive_left {
          margin-left: 80px;
          color: #a8adb5;
        }

        .towNum {
          padding: 0 3px;
          color: white;
          background-color: #dc433d;
          margin: 2px;
          border-radius: 2px;
          overflow: hidden;
        }

        span {
          padding: 0 3px;
          color: white;
          background-color: #454545;
          margin: 2px;
          border-radius: 2px;
          overflow: hidden;
        }

        img {
          width: 100px;
          margin-left: 10px;
          margin-bottom: 5px;
        }
      }
    }

  }
}
.paynewBoxDon {
  // background: rgba(0, 0, 0, 0);
  -webkit-animation: slide-bck-br2 1s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;
  animation: slide-bck-br2 1s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;

  @-webkit-keyframes slide-bck-br2 {
    0% {
      -webkit-transform: translateZ(0) translateY(0) translateX(0);
      transform: translateZ(0) translateY(0) translateX(0);
    }

    100% {
      -webkit-transform: translateZ(100px) translateY(-260px) translateX(-260px) scale(0);
      transform: translateZ(100px) translateY(-260px) translateX(-260px) scale(0);
    }
  }

  @keyframes slide-bck-br2 {
    0% {
      -webkit-transform: translateZ(0) translateY(0) translateX(0);
      transform: translateZ(0) translateY(0) translateX(0);
    }

    100% {
      -webkit-transform: translateZ(100px) translateY(-260px) translateX(-260px) scale(0);
      transform: translateZ(-200px) translateY(-500px) translateX(700px) scale(0);
    }
  }

}
</style>